class FilterModalValueViewStub {
  undelegateEvents () {}
  remove () {}
  render () {}
}
export default FilterModalValueViewStub